// extracted by mini-css-extract-plugin
module.exports = {"warning_message":"c6e8ba5398--warning_message--RDYSj"};